import { z } from "zod";

const settlementNoteTemplateDataZodSchema = z.object({
    month_range: z.string(),
    serial_number: z.string(),
    document_date: z.string(),
    time_range_start: z.string(),
    time_range_end: z.string(),
    recipient_legal_name: z.string(),
    recipient_name: z.string(),
    recipient_org_nr: z.string(),
    recipient_vat_no: z.string(),
    recipient_address_row_1: z.string(),
    recipient_address_row_2: z.string(),
    sales_excl_vat_amount: z.string(),
    sales_incl_vat_amount: z.string(),
    vat_distribution: z.array(
        z.object({
            percent: z.string(),
            vat_amount: z.string(),
        })
    ),
    vat_total_amount: z.string(),
    platform_name: z.string(),
    sender_legal_name: z.string(),
    settlement_rows: z.array(
        z.object({
            name: z.string(),
            value: z.string(),
        })
    ),
    payout_amount: z.string(),
    payout_init_date: z.string(),
    payout_target_name: z.string(),
    payout_target_value: z.string(),
    sender_address_row_1: z.string(),
    sender_address_row_2: z.string(),
    sender_email: z.string(),
    sender_org_no: z.string(),
    sender_vat_no: z.string(),
});
type SettlementNoteTemplateData = z.infer<
    typeof settlementNoteTemplateDataZodSchema
>;

export type { SettlementNoteTemplateData };
export { settlementNoteTemplateDataZodSchema };
